<!-- Navigation -->
<nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top" style="z-index:1!important">
  <div class="container">
    <span><a class="navbar-brand" [routerLink]="'/home'" style="color:white">IBK Projektdatenbank</a></span>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarResponsive">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item " [ngClass]="{'active': this.isActive('/home')}">
          <a class="nav-link" routerLink="/home">
            Projekt Übersicht
            <span class="sr-only">(current)</span>
          </a>
        </li>
        <!--<li class="nav-item">
          <a class="nav-link" id="auftraege" routerLink="/home/test" [ngClass]="{'active': this.isActive('/home/test')}">Test</a>
        </li>-->

      </ul>
    </div>
  </div>
</nav>
